// src/pages/profile-settings/patient/SettingsProfile.jsx
import React from "react";
import List from "@/sot/primitives/List.jsx";
import SettingsChevron from "@/sot/primitives/SettingsChevron.jsx";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext.jsx";
import { PATIENT_SETTINGS_PROFILE_ROUTE } from "@/pages/profile-settings/settingsNavigation.js";

export default function SettingsProfile() {
  const nav = useNavigate();
  const { t, languageCode } = useLanguage();
  const isFrench = String(languageCode || "").trim().toLowerCase().startsWith("fr");
  return (
    <div className="space-y-6">
      <List
        items={[
          {
            title: t("settings.profile.patient.editIntro", isFrench ? "Modifier l’intro" : "Edit Intro"),
            trailing: <SettingsChevron />,
            onClick: () => nav("/settings/patient/p/edit-intro"),
          },
          {
            title: t("settings.profile.common.editName", isFrench ? "Modifier le nom" : "Edit Name"),
            trailing: <SettingsChevron />,
            onClick: () => nav("/settings/patient/p/edit-name"),
          },
          {
            title: t("settings.profile.common.editDob", isFrench ? "Modifier la date de naissance" : "Edit Date of Birth"),
            trailing: <SettingsChevron />,
            onClick: () => nav("/settings/patient/p/edit-dob"),
          },
          {
            title: t("settings.profile.common.editPhone", isFrench ? "Modifier le téléphone" : "Edit Phone"),
            trailing: <SettingsChevron />,
            onClick: () => nav("/settings/patient/p/edit-phone"),
          },
          {
            title: t("settings.profile.common.editEmail", isFrench ? "Modifier l’e-mail" : "Edit Email"),
            trailing: <SettingsChevron />,
            onClick: () => nav("/settings/patient/p/edit-email"),
          },
          {
            title: t("settings.profile.common.idPassport", isFrench ? "Carte d’identité nationale • passeport" : "National ID • Passport"),
            trailing: <SettingsChevron />,
            onClick: () => nav("/settings/patient/p/edit-id-passport"),
          },
          {
            title: t("settings.profile.common.address", isFrench ? "Adresse" : "Address"),
            trailing: <SettingsChevron />,
            onClick: () => nav("/settings/patient/p/edit-address"),
          },
          {
            title: t("settings.profile.common.languages", isFrench ? "Langues" : "Languages"),
            trailing: <SettingsChevron />,
            onClick: () => nav("/settings/patient/p/languages"),
          },
          {
            title: t("settings.profile.patient.bloodType", isFrench ? "Groupe sanguin" : "Blood type"),
            trailing: <SettingsChevron />,
            onClick: () => nav("/settings/patient/p/blood-type"),
          },
          {
            title: t("settings.profile.patient.allergies", isFrench ? "Allergies" : "Allergies"),
            trailing: <SettingsChevron />,
            onClick: () => nav("/settings/patient/p/allergies"),
          },
          {
            title: t("settings.profile.patient.conditions", isFrench ? "Antécédents médicaux" : "Medical conditions"),
            trailing: <SettingsChevron />,
            onClick: () => nav("/settings/patient/p/conditions"),
          },
          {
            title: t("settings.profile.patient.medications", isFrench ? "Médicaments" : "Medications"),
            trailing: <SettingsChevron />,
            onClick: () => nav("/settings/patient/p/medications"),
          },
          {
            title: t("settings.profile.patient.organDonor", isFrench ? "Don d’organes" : "Organ donor"),
            trailing: <SettingsChevron />,
            onClick: () => nav("/settings/patient/p/organ-donor"),
          },
          {
            title: t("settings.profile.patient.heightWeight", isFrench ? "Taille et poids" : "Height & Weight"),
            trailing: <SettingsChevron />,
            onClick: () =>
              nav("/settings/patient/p/height-weight", {
                state: { returnTo: PATIENT_SETTINGS_PROFILE_ROUTE },
              }),
            divider: false, // last item in the group
          },
        ]}
      />
    </div>
  );
}
